// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan{position:relative;margin-bottom:10px}.title{padding:20px 10px;display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;text-align:center;color:#fbfbfb;border-radius:10px}.title.basic{background-color:#166090}.title.pro{background-color:#3b1690}.title.expert{background-color:#000}.title.sleep{background-color:#848ead}.title h1{font-weight:bold;font-size:16px;text-transform:uppercase}.limit-width{max-width:350px}", ""]);
// Exports
module.exports = exports;
